<template
  ><div class="mi-checkout page-main">
    <div class="container">
      <div data-v-0166ce07="" class="checkout-wrap">
        <!---->
        <div data-v-0166ce07="" class="loading" style="display: none;">
          <div data-v-0166ce07="" class="loader"></div>
        </div>
        <div data-v-0166ce07="" class="checkout-main" style="">
          <div data-v-0166ce07="" class="checkout-detail">
            <div data-v-0166ce07="" class="detail-section address-detail">
              <div data-v-0166ce07="" class="address-header">
                <span data-v-0166ce07="" class="header-title">收货地址</span>
              </div>
              <div class="address-list show-less-list">
                <div
                  data-v-039a89f6=""
                  class="address-item"
                  v-for="(item, index) in address_list"
                  :key="index"
                  v-show="isShow(index)"
                  @click="onSelectAddresss(item)"
                  :class="getAddressClass(item)"
                >
                  <div data-v-039a89f6="" class="address-info">
                    <div data-v-039a89f6="" class="name">
                      {{ item.name
                      }}<span
                        data-v-039a89f6=""
                        style="color: rgb(176, 176, 176);"
                      ></span>
                    </div>
                    <div data-v-039a89f6="" class="tel">{{ item.mobile }}</div>
                    <div data-v-039a89f6="" class="address-con">
                      <span data-v-039a89f6="">{{ item.province }}</span
                      ><span data-v-039a89f6="">{{ item.city }}</span
                      ><span data-v-039a89f6="">{{ item.district }}</span
                      ><span data-v-039a89f6="" class="info">{{
                        item.address
                      }}</span>
                    </div>
                    <div data-v-039a89f6="" class="address-action">
                      <span data-v-039a89f6="" @click="onShowEditAddress(item)"
                        >修改</span
                      ><!---->
                    </div>
                  </div>
                </div>
                <div
                  data-v-039a89f6=""
                  class="address-item"
                  v-show="isShow(address_list.length)"
                >
                  <div
                    data-v-039a89f6=""
                    class="add-desc"
                    @click="onShowAddAddress"
                  >
                    <i data-v-039a89f6="" class="iconfont iconfont-plus"></i
                    ><span data-v-039a89f6="">添加新地址</span>
                  </div>
                </div>
                <!---->
                <div
                  data-v-039a89f6=""
                  class="more-btn"
                  v-show="address_list.length > 3"
                  @click="toggleMoreAddress"
                >
                  <span v-show="!is_show_more" data-v-039a89f6=""
                    >显示更多地址<i data-v-039a89f6="" class="iconfont-normal"
                      ></i
                    ></span
                  ><span v-show="is_show_more"
                    >收起更多地址<i data-v-039a89f6="" class="iconfont-normal"
                      ></i
                    ></span
                  >
                </div>
              </div>
            </div>
            <div data-v-0166ce07="" class="detail-section">
              <div data-v-0166ce07="" class="detail-header">商品及优惠券</div>
              <div data-v-73ddf45a="" data-v-0166ce07="" class="goods-list">
                <div
                  data-v-73ddf45a=""
                  class="good-item"
                  v-for="(item, index) in order.item_list"
                  :key="index"
                >
                  <div data-v-73ddf45a="" class="item-desc good-img">
                    <el-image :src="item.goods_image"> </el-image>
                    <img data-v-73ddf45a="" />
                  </div>
                  <div data-v-73ddf45a="" class="item-desc good-name">
                    <a
                      data-v-73ddf45a=""
                      :href="'/detail/' + item.id"
                      target="_blank"
                      ><span data-v-73ddf45a="">{{ item.goods_name }}</span
                      ><!----></a
                    ><!---->
                  </div>
                  <div data-v-73ddf45a="" class="item-desc price-box">
                    <div data-v-73ddf45a="" class="item-desc good-price">
                      {{ item.price }} 元 x {{ item.qty }}
                    </div>
                    <div data-v-73ddf45a="" class="item-desc good-status"></div>
                    <div data-v-73ddf45a="" class="item-desc good-total">
                      {{ item.amount }} 元
                    </div>
                    <!---->
                  </div>
                </div>
              </div>
            </div>
            <div data-v-0166ce07="" class="detail-section">
              <!---->
              <div data-v-0166ce07="" class="section-options section-shipment">
                <div data-v-0166ce07="" class="options-desc options-header">
                  <div data-v-0166ce07="" class="title">配送方式</div>
                </div>
                <div data-v-0166ce07="" class="options-desc options-body">
                  <div data-v-0166ce07="" class="options-list">
                    <div data-v-0166ce07="" class="options-item selected">
                      包邮
                    </div>
                  </div>
                </div>
              </div>
              <div data-v-0166ce07="" class="section-options section-invoice">
                <div data-v-0166ce07="" class="options-desc options-header">
                  <div data-v-0166ce07="" class="title">发票</div>
                </div>
                <div data-v-0166ce07="" class="options-desc options-body">
                  <div data-v-0166ce07="" class="options-list">
                    <div data-v-0166ce07="" class="options-item selected">
                      电子普通发票
                    </div>
                    <div data-v-0166ce07="" class="options-item selected">
                      个人
                    </div>
                    <div data-v-0166ce07="" class="options-item selected">
                      商品明细
                    </div>
                    <a
                      data-v-0166ce07=""
                      data-log_code="bid=3515489.4&amp;bpm=25.83.3513652.1"
                      href="javascript:void(0);"
                      class="options-item selected"
                      data-settrack="true"
                      onclick="_msq.push(['trackEvent','bid=3515489.4&amp;bpm=25.83.3513652.1','javascript:void(0);','&quot;&quot;']);"
                      >修改 &gt;</a
                    >
                  </div>
                </div>
              </div>
            </div>
            <div data-v-0166ce07="" class="detail-section count-detail">
              <!---->
              <div
                data-v-0166ce07=""
                class="section-discount"
                style="display:none"
              >
                <div data-v-0166ce07="" class="discount-coupon">
                  <a
                    data-v-0166ce07=""
                    href="javascript:void(0)"
                    data-log_code="bid=3515489.5&amp;bpm=25.83.3514683.1"
                    class="coupon-title"
                    data-settrack="true"
                    onclick="_msq.push(['trackEvent','bid=3515489.5&amp;bpm=25.83.3514683.1','javascript:void(0)','&quot;&quot;']);"
                    ><i data-v-0166ce07="" class="iconfont icon-plus"></i
                    ><span data-v-0166ce07="">使用优惠券</span></a
                  ><!----><!---->
                </div>
                <!---->
                <div data-v-0166ce07="" class="position-box">
                  <div data-v-0166ce07="" class="discount-ecard">
                    <a
                      data-v-0166ce07=""
                      data-log_code="bid=3515489.6&amp;bpm=25.83.3514684.1"
                      class="coupon-title"
                      data-settrack="true"
                      onclick="_msq.push(['trackEvent','bid=3515489.6&amp;bpm=25.83.3514684.1','','&quot;&quot;']);"
                      ><i data-v-0166ce07="" class="iconfont icon-plus"></i
                      ><span data-v-0166ce07="">使用小米礼品卡</span></a
                    ><!---->
                  </div>
                  <!----><!---->
                </div>
                <!---->
              </div>
              <div data-v-0166ce07="" class="section-bill">
                <div data-v-0166ce07="" class="bill-item">
                  <div data-v-0166ce07="" class="bill-name">商品件数：</div>
                  <div data-v-0166ce07="" class="bill-money">
                    {{ order.total_qty }} 件
                  </div>
                </div>
                <!----><!---->
                <div data-v-0166ce07="" class="bill-item">
                  <div data-v-0166ce07="" class="bill-name">商品总价：</div>
                  <div data-v-0166ce07="" class="bill-money">
                    {{ order.total_amount }} 元
                  </div>
                </div>
                <!---->
                <div data-v-0166ce07="" class="bill-item">
                  <div data-v-0166ce07="" class="bill-name">优惠：</div>
                  <div data-v-0166ce07="" class="bill-money">
                    {{ order.total_discount }} 元
                  </div>
                </div>
                <!----><!----><!---->
                <div data-v-0166ce07="" class="bill-item">
                  <div data-v-0166ce07="" class="bill-name">运费：</div>
                  <div data-v-0166ce07="" class="bill-money">
                    {{ order.freight_amount }} 元
                  </div>
                </div>
                <div data-v-0166ce07="" class="bill-item total-price">
                  <div data-v-0166ce07="" class="bill-name">应付总额：</div>
                  <div data-v-0166ce07="" class="bill-money">
                    <em data-v-0166ce07="">{{ order.total_payment }}</em
                    >元
                  </div>
                </div>
              </div>
            </div>
            <div
              data-v-0166ce07=""
              class="detail-section footer-detail clearfix"
            >
              <!---->
              <div data-v-0166ce07="" class="handle-action">
                <div data-v-0166ce07="" class="operating-button">
                  <a
                    data-v-0166ce07=""
                    href="javascript:void(0);"
                    class="btn btn-primary"
                    data-settrack="true"
                    @click="goPay(order)"
                    >去结算</a
                  ><a
                    data-v-0166ce07=""
                    href="javascript:void(0);"
                    class="btn btn-return"
                    >返回购物车</a
                  >
                </div>
                <!---->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="添加收货地址" v-model="is_show_add" :width="600">
      <el-form v-model="form">
        <el-input
          v-model="form.name"
          autocomplete="off"
          style="width:273px;margin-right:7px;"
          placeholder="姓名"
        ></el-input>
        <el-input
          v-model="form.mobile"
          autocomplete="off"
          style="width:273px;margin-left:7px;"
          placeholder="手机号"
        ></el-input>
        <input type="hidden" v-model="form.area_text" />
        <el-cascader
          size="large"
          :options="options"
          v-model="form.area"
          @change="handleChange"
          style="width:100%;margin-top:20px;margin-bottom:20px;"
          placeholder="省 / 市 / 区"
        >
        </el-cascader>
        <el-input
          v-model="form.address"
          autocomplete="off"
          type="textarea"
          :rows="3"
        ></el-input>
        <div style="margin-top:20px;text-align:center">
          <el-button type="primary" @click="onAddAddress">确定</el-button>
          <el-button @click="is_show_add = false">取消</el-button>
        </div>
      </el-form>
    </el-dialog>
    <el-dialog title="修改收货地址" v-model="is_show_address" :width="600">
      <el-form v-model="form2">
        <el-input
          v-model="form2.name"
          autocomplete="off"
          style="width:273px;margin-right:7px;"
          placeholder="姓名"
        ></el-input>
        <el-input
          v-model="form2.mobile"
          autocomplete="off"
          style="width:273px;margin-left:7px;"
          placeholder="手机号"
        ></el-input>
        <input type="hidden" v-model="form2.area_text" />
        <el-cascader
          size="large"
          :options="options"
          v-model="form2.area"
          @change="handleChange2"
          style="width:100%;margin-top:20px;margin-bottom:20px;"
          placeholder="省 / 市 / 区"
        >
        </el-cascader>
        <el-input
          v-model="form2.address"
          autocomplete="off"
          type="textarea"
          :rows="3"
        ></el-input>
        <div style="margin-top:20px;text-align:center">
          <el-button type="primary" @click="onSaveAddress">确定</el-button>
          <el-button @click="is_show_address = false">取消</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { regionData, CodeToText } from "element-china-area-data";
import { api, session } from "@/assets/js/util.js";

export default {
  name: "Login",
  data() {
    return {
      active_address: "",
      address_list: [],
      order: {},
      is_show_address: false,
      is_show_add: false,
      options: regionData,
      is_show_more: false,
      form: {},
      form2: {},
      address_id: "",
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getAddressClass(item) {
      if (item.id === this.address_id) {
        return "active";
      }
    },
    onSelectAddresss(item) {
      console.log(item);
      this.address_id = item.id;
    },
    toggleMoreAddress() {
      if (this.is_show_more) {
        this.is_show_more = false;
      } else {
        this.is_show_more = true;
      }
    },
    isShow(index) {
      if (this.is_show_more) {
        return true;
      } else {
        if (index < 4) {
          return true;
        }
      }
    },
    onShowAddAddress() {
      this.is_show_add = true;
    },
    onAddAddress() {
      let that = this;
      api.post("address/add", that.form).then(function(res) {
        if (res.code) {
          that.form = res.data;
          that.is_show = false;
          that.$message({
            type: "success",
            message: res.msg,
            duration: 1200,
            onClose: function() {
              that.getData();
              that.is_show_add = false;
            },
          });
        }
      });
    },
    onShowEditAddress(item) {
      let that = this;
      api.get("address/edit", item).then(function(res) {
        if (res.code) {
          that.form2 = res.data;
          that.is_show_address = true;
        }
      });
    },
    onSaveAddress() {
      let that = this;
      console.log(that.form);
      api.post("address/edit", that.form2).then(function(res) {
        if (res.code) {
          that.getData();
          that.is_show2 = false;
          that.$message({
            type: "success",
            message: res.msg,
            duration: 1200,
          });
        }
      });
    },
    handleChange() {
      var area_text = [];
      for (let i = 0; i < this.form.area.length; i++) {
        area_text.push(CodeToText[this.form.area[i]]);
      }
      this.form.area_text = area_text;
    },
    handleChange2() {
      var area_text = [];
      for (let i = 0; i < this.form2.area.length; i++) {
        area_text.push(CodeToText[this.form2.area[i]]);
      }
      this.form2.area_text = area_text;
    },
    getData() {
      let that = this;
      let params = this.$route.params;
      api.get("order/checkout", params).then(function(res) {
        if (res.code) {
          that.address_list = res.data.address_list;
          that.order = res.data.order;
        } else {
          that.$message(res.msg);
          return false;
        }
      });
    },
    goPay(order) {
      let that = this;
      if (that.address_id === "") {
        that.$message({
          type: "error",
          message: "请选择收货地址",
          duration: 1200,
        });
        return false;
      }

      let params = {
        order_id: order.id,
        address_id: that.address_id,
      };

      api.post("order/pay", params).then(function(res) {
        if (res.code) {
          that.$router.push("/order/confirm/" + res.data.id);
        } else {
          that.$message(res.msg);
          return false;
        }
      });
    },
  },
};
</script>
